module.exports = __webpack_public_path__ + "static/img/bg1.edff9b31.png";